export default __webpack_public_path__ + "static/media/Frame 108.f31cdfc6.svg";